import { motion } from 'framer-motion';
import { Button as PrimeButton } from 'primereact/button';

const Button = (props: any) => {
  const AnimatedButton = motion(PrimeButton);
  return <AnimatedButton {...props} whileTap={{ scale: 0.95 }} />;
};

export default Button;
